export default "__VITE_ASSET__Bkv8258s__"